import { abi } from './abi';
import { REGISTRY_CONTRACT_ADDRESS } from './constants';
export class Registry {
    constructor(client, { address } = {}) {
        this.getContract = ({ registryKey }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getContract',
            args: [registryKey]
        });
        this.client = client;
        this.address = address ?? REGISTRY_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=registry.js.map